import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import {
  CompanyTimeRegistrationPolicyView,
  CompanyUnitSetting,
  CompanyUnitState,
} from 'types/company/time-registration/ICompanyTimeRegistrationPolicy';
import { ICostCentresCoordinatesStatusResponse } from 'types/time-registration';
import { PolicyUnit } from 'types/time-registration-policy/ITimeRegistrationPolicy';

const BASE_URL = 'CompanyTimeRegistrationPolicy';
const SAVE_TIMEOUT_MS = 30000;

export const getCompanyTimeRegistrationPolicy = async (
  companyId: number,
): Promise<CompanyTimeRegistrationPolicyView> => {
  const response: AxiosResponse<CompanyTimeRegistrationPolicyView> = await getApi().get(`${BASE_URL}/${companyId}`);
  return response.data;
};

export const putCompanyPolicyUnit = async (
  companyId: number,
  unit: PolicyUnit,
  expected: CompanyUnitSetting,
  proposed: CompanyUnitSetting,
): Promise<CompanyUnitState> => {
  const response: AxiosResponse<CompanyUnitState> = await getApi().put(
    `${BASE_URL}/${companyId}/${PolicyUnit[unit]}`,
    { expected, proposed },
    { timeout: SAVE_TIMEOUT_MS },
  );
  return response.data;
};

export const getCostCentresCoordinatesStatusRequest = async (
  companyId: number,
): Promise<ICostCentresCoordinatesStatusResponse> => {
  const response: AxiosResponse<ICostCentresCoordinatesStatusResponse> = await getApi().get(
    `timeregistration/cost-centres/coordinates-status`,
    { headers: { companyId } },
  );
  return response.data;
};
